import { mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'

export const Info = styled.div`
  ${mixins.typography.paragraphSmall};
  ${mixins.padding.top(20)};
  ${mixins.media.min.desktop} {
    ${mixins.padding.top(10)};
  }
`

export const InfoAddress = styled.div`
  display: flex;
  flex-direction: column;
  ${mixins.margin.bottom(15)};
`

export const InfoContact = styled.a`
  display: block;
  ${mixins.margin.bottom(15)};
`

export const InfoLogo = styled(Asset)`
  max-width: 80%;
  margin: 15px auto 0 auto;
`
